import React, { useEffect, useState, useCallback } from "react";
import "./Header.css";
import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";
import Select from "react-select";
import { FiSearch } from "react-icons/fi";
import moment from "moment";

const backend = await new Backend().init();
const customStyles = {
  control: (base) => ({
    ...base,
    borderRadius: "20px",
    paddingLeft: "28px",
    border: "none",
    minHeight: "36px",
    backgroundColor: "var(--hover)", // ← bg theme
    boxShadow: "none",
    color: "var(--text)",
  }),

  placeholder: (base) => ({
    ...base,
    color: "var(--text)",
    opacity: 0.6,
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: "var(--background)",
    overflow: "hidden",
    borderRadius: "12px",
    border: "2px solid var(--hover)", // <— your border
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)", // <— card shadow
    marginTop: "6px",
    padding: "4px",
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? "var(--primary)" : "transparent",
    color: isFocused ? "#fff" : "var(--text)",
    cursor: "pointer",
  }),
  singleValue: (base) => ({
    ...base,
    color: "var(--text)",
  }),
  input: (base) => ({
    ...base,
    color: "var(--text)",
  }),
};
export default function Header({
  master,
  updateType,
  userType,
  type,
  onFilter,
}) {
  const [supers, setSupers] = useState([]);
  const [masters, setMasters] = useState([]);

  const [superFilter, setSuperFilter] = useState([]);
  const [masterFilter, setMasterFilter] = useState([]);

  const [superId, setSuperId] = useState(null);
  const [masterId, setMasterId] = useState(null);

  const [loading, setLoading] = useState(false);

  const [start, setStart] = useState(
    moment().startOf("week").format("YYYY-MM-DD"),
  );
  const [end, setEnd] = useState(moment().endOf("week").format("YYYY-MM-DD"));

  const handleFilter = () => {
    try {
      onFilter?.({
        start,
        end,
      });
    } catch {
      toast.error("Invalid selection");
    }
  };

  // Load filters
  useEffect(() => {
    if (userType === 1) loadSuperFilter();
    if (userType === 2) loadMasterFilter();
  }, [userType]);

  // Load Super List
  const loadSuperFilter = useCallback(async () => {
    setLoading(true);
    try {
      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        admin_id: localStorage.getItem("id"),
      };

      const res = await backend.user_filter(data);
      if (res.error === "False") {
        setSupers(res.user);
        setSuperFilter(res.user);
      } else toast.error(res.message);
    } catch (e) {
      toast.error("Failed to load supers");
    }
    setLoading(false);
  }, []);

  // Load Masters
  const loadMasterFilter = useCallback(
    async (superId = null) => {
      setLoading(true);
      try {
        const data = {
          server: localStorage.getItem("server"),
          id: localStorage.getItem("id"),
          username: localStorage.getItem("username"),
          token: localStorage.getItem("token"),
          super_id: userType === 1 ? superId : localStorage.getItem("id"),
        };

        const res = await backend.user_filter(data);
        if (res.error === "False") {
          setMasters(res.user);
          setMasterFilter(res.user);
        } else toast.error(res.message);
      } catch (e) {
        toast.error("Failed to load masters");
      }
      setLoading(false);
    },
    [userType],
  );

  // Search filter
  const searchSuper = (txt) => {
    const q = txt.toLowerCase();
    setSupers(
      q.length > 1
        ? superFilter.filter((x) => x.username.toLowerCase().includes(q))
        : superFilter,
    );
  };

  const searchMaster = (txt) => {
    const q = txt.toLowerCase();
    setMasters(
      q.length > 1
        ? masterFilter.filter((x) => x.username.toLowerCase().includes(q))
        : masterFilter,
    );
  };

  const Clear = () => {
    setSuperId(null);
    setMasterId(null);
    master(null);
  };

  // Navigation
  const Create = () => updateType(0);
  const Bank = () => updateType(1);
  const Deposit = () => updateType(2);
  const Withdrawal = () => updateType(3);

  return (
    <div className="h-[55px] bg-[var(--background)] items-center flex pr-4 pl-4">
      {/* LEFT BUTTONS */}
      <div className="UserLeft addHeaderFlex">
        <button
          onClick={Bank}
          className={`NavLinkBtn marginright ${
            type === 1 ? "selectlink" : "unselectlink"
          }`}
        >
          BANK
        </button>

        <button
          onClick={Deposit}
          className={`NavLinkBtn marginright ${
            type === 2 ? "selectlink" : "unselectlink"
          }`}
        >
          DEPOSIT
        </button>

        <button
          onClick={Withdrawal}
          className={`NavLinkBtn marginright ${
            type === 3 ? "selectlink" : "unselectlink"
          }`}
        >
          WITHDRAWAL
        </button>
      </div>

      {/* RIGHT SIDE */}
      <div className="UserRight">
        {/* ============================= SUPER DROPDOWN ============================= */}
        {userType === 1 &&
          (superId ? (
            <button className="NavLinkBtn marginright unselectlink">
              SUPER : {superId.username}
            </button>
          ) : (
            <div className="relative mr-4 w-[240px]">
              <FiSearch
                className="absolute left-3 top-1/2 -translate-y-1/2 text-[18px] z-10"
                style={{ color: "var(--text)" }}
              />

              <Select
                placeholder={loading ? "Loading..." : "Select Super"}
                value={superId}
                onInputChange={searchSuper}
                onChange={(obj) => {
                  setSuperId(obj);
                  loadMasterFilter(obj.super_id);
                }}
                options={supers.map((s) => ({
                  value: s.id,
                  label: s.username,
                  ...s,
                }))}
                styles={customStyles}
                isSearchable
              />
            </div>
          ))}

        {/* ============================= MASTER DROPDOWN ============================= */}
        {(userType === 1 || userType === 2) &&
          (masterId ? (
            <button className="NavLinkBtn marginright unselectlink">
              MASTER : {masterId.username}
            </button>
          ) : (
            <div className="relative mr-2 w-[240px]">
              <FiSearch
                className="absolute left-3 top-1/2 -translate-y-1/2 text-[18px] z-10"
                style={{ color: "var(--text)" }}
              />

              <Select
                placeholder="Select Master"
                value={masterId}
                onInputChange={searchMaster}
                onChange={(obj) => {
                  setMasterId(obj);
                  master(obj.master_id);
                }}
                options={masters.map((m) => ({
                  value: m.id,
                  label: m.username,
                  ...m,
                }))}
                styles={customStyles}
                isSearchable
              />
            </div>
          ))}

        {/* DATE PICKERS */}
        <input
          type="date"
          value={start}
          max={moment().format("YYYY-MM-DD")}
          onChange={(e) => setStart(e.target.value)}
          style={{
            background: "var(--background)",
            border: "2px solid var(--hover)",
            color: "var(--text)",
            padding: "6px 10px",
            borderRadius: "6px",
            marginRight: "10px",
          }}
        />

        <input
          type="date"
          value={end}
          max={moment().format("YYYY-MM-DD")}
          onChange={(e) => setEnd(e.target.value)}
          style={{
            background: "var(--background)",
            border: "2px solid var(--hover)",
            color: "var(--text)",
            padding: "6px 10px",
            borderRadius: "6px",
            marginRight: "10px",
          }}
        />

        {/* FILTER BTN */}
        <button
          onClick={handleFilter}
          className="px-4 py-1.5 mr-3 bg-[var(--primary)] text-white rounded-full text-sm font-semibold shadow"
        >
          Filter
        </button>

        {/* CREATE USER BUTTON */}
        {(userType === 1 || userType === 2) && masterId && (
          <button
            onClick={Create}
            className="NavLinkBtn marginright unselectlink"
          >
            ADD BANK ACCOUNT
          </button>
        )}

        {/* CLEAR BUTTON */}
        {(userType === 1 || userType === 2) && (superId || masterId) && (
          <button
            onClick={Clear}
            className="dropbtnNavSub sell marginright white"
          >
            CLEAR
          </button>
        )}

        {/* FOR USER TYPE 3 */}
        {userType === 3 && (
          <button
            onClick={Create}
            className="NavLinkBtn marginright unselectlink"
          >
            ADD BANK ACCOUNT
          </button>
        )}
      </div>
    </div>
  );
}
